if(!customElements.get('cart-discount')) {
    class CartDiscount extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.selectors = {
                input: this.querySelector('input'),
                button: this.querySelector('button'),
            }
            this.selectors.button.addEventListener('click', (event) => {
                if(this.selectors.input.value != "") {
                    this.applyDiscountCode(event.target.closest('button'));
                } else {
                    this.selectors.input.focus();
                }                
            })
        }
        async applyDiscountCode(target) {
            target.classList.add('active');
            await fetch(`/discount/${this.selectors.input.value}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(async response => {
                if(response.ok) {
                    if(location.pathname.includes('/cart')) {
                        await this.repaintMainCart();
                    } else {
                        await this.repaintCartDrawer();
                    }
                    target.classList.remove('active');
                    this.selectors.input.value = '';
                } else {
                    console.error(error);
                }
            })
            .catch(error => {
                console.error(error);
            });
        }
        async repaintCartDrawer() {
            await fetch(window.Shopify.routes.root + '?sections=mini_cart')
            .then(response => {
                return response.json();
            })
            .then(async data => {
                const parser = new DOMParser();
                const htmlDoc = parser.parseFromString(data["mini_cart"], 'text/html');                
                const cartDrawerItems = htmlDoc.querySelector('[data-cart-items]');
                const docCartDrawerItems = document.querySelector('[data-cart-items]');
                const cartDiscounts = htmlDoc.querySelector('[data-cart-discounts]');
                const docCartDiscounts = document.querySelector('[data-cart-discounts]');
                const cartPrices = htmlDoc.querySelector('[data-cart-prices]');
                const docCartPrices = document.querySelector('[data-cart-prices]');
                docCartDrawerItems.innerHTML = cartDrawerItems.innerHTML;
                docCartDiscounts.innerHTML = cartDiscounts.innerHTML;
                docCartPrices.innerHTML = cartPrices.innerHTML;
            })
            .catch(error => {
                console.error(error);
            });
        }
        async repaintMainCart() {
            await fetch(window.Shopify.routes.root + '?sections=main-cart')
            .then(response => {
                return response.json();
            })
            .then(async data => {
                const parser = new DOMParser();
                const htmlDoc = parser.parseFromString(data["main-cart"], 'text/html');                
                const cartDrawerItems = htmlDoc.querySelector('[data-cart-items]');
                const docCartDrawerItems = document.querySelector('[data-cart-items]');
                const cartDiscounts = htmlDoc.querySelector('[data-cart-discounts]');
                const docCartDiscounts = document.querySelector('[data-cart-discounts]');
                const cartPrices = htmlDoc.querySelector('[data-cart-prices]');
                const docCartPrices = document.querySelector('[data-cart-prices]');
                docCartDrawerItems.innerHTML = cartDrawerItems.innerHTML;
                docCartDiscounts.innerHTML = cartDiscounts.innerHTML;
                docCartPrices.innerHTML = cartPrices.innerHTML;
            })
            .catch(error => {
                console.error(error);
            });
        }
    }
    customElements.define('cart-discount', CartDiscount);
}